<template>
  <div class="footer">
    <div class="top container">
      <div class="item">
        <div class="title">
          <span class="desc">客服热线</span>
          <span class="line"></span>
        </div>
        <div class="content">
          <div class="tel">
            <img src="@/assets/images/service-telephone.png" alt />
            <span v-if="platMsg.length > 0">{{ platMsg[9].value }}</span>
          </div>
          <div v-if="platMsg.length > 0" class="time">{{ platMsg[10].value }}</div>
          <!-- <div class="btn" @click="setToconsule(true)">在线咨询</div> -->
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span class="desc">我们的产品</span>
          <span class="line"></span>
        </div>
        <div class="content">
          <a
            v-for="(v, i) in product"
            v-show="platMsg.length > 0"
            :key="i"
            :href="v.url"
            target="_blank"
            class="xthk-online"
          >
            {{ v.name }}
            <img v-show="v.name === '心田花开在线'" class="hot" src="@/assets/images/hot-o.png" alt />
          </a>
        </div>
      </div>

      <div class="item">
        <div class="title">
          <span class="desc">关注我们</span>
          <span class="line"></span>
        </div>
        <div class="content last">
          <div class="last-school">
            <img
              class="chat"
              src="@/assets/images/wechat-friend.png"
              @mouseenter="change(1, true)"
              @mouseleave="change(1, false)"
            />
            <span @mouseenter="change(1, true)" @mouseleave="change(1, false)">心田花开服务号</span>
            <div v-if="toschool" class="wechat-QR">
              <img v-if="platMsg.length > 0" :src="platMsg[12].value" alt />
            </div>
          </div>
          <!-- <div class="last-online">
            <img
              class="chat"
              src="@/assets/images/wechat-friend.png"
              @mouseenter="change(2, true)"
              @mouseleave="change(2, false)"
            />
            <span @mouseenter="change(2, true)" @mouseleave="change(2, false)">心田花开网校</span>
            <div v-if="towechat" class="wechat-QR">
              <img v-if="platMsg.length > 0" :src="platMsg[13].value" alt />
            </div>
          </div> -->
          <div class="last-service">
            <img
              class="chat"
              src="@/assets/images/wechat-friend.png"
              @mouseenter="change(3, true)"
              @mouseleave="change(3, false)"
            />
            <span @mouseenter="change(3, true)" @mouseleave="change(3, false)">心田花开招聘</span>
            <div v-if="toservice" class="wechat-QR">
              <img v-if="platMsg.length > 0" :src="platMsg[14].value" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">
          <span class="desc">加入我们</span>
          <span class="line"></span>
        </div>
        <div class="content">
          <a href="https://app.mokahr.com/apply/xintianhuakai/29193" target="_blank" class="join-us">
            加入我们
            <img src="@/assets/images/friendly-link.png" alt />
          </a>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="record container">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="pol-num">蜀ICP备2024069709号-1</a>
        <span>
          Copyright © 成都心田花开教育咨询有限公司 2016-
          <span>{{ year }}</span
          >.All right reserved
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { platformDetail } from '@/libs/api'

export default {
  data() {
    return {
      towechat: false, //心田花开在线标识
      toschool: false, //心田花开学校标识
      toservice: false, //服务号标识
      platMsg: [], // 平台信息
      product: [], //我们的产品
      year: '' //当前年
    }
  },
  computed: {
    toconsule() {
      return this.$store.getters.getToconsule
    }
  },

  mounted() {
    this.getMsg()
    this.getYear()
  },
  methods: {
    change(num, val) {
      switch (num) {
        case 1:
          this.toschool = val
          break
        case 2:
          this.towechat = val
          break
        case 3:
          this.toservice = val
          break
      }
    },
    setToconsule(val) {
      this.$store.commit('setToconsule', val)
    },
    getMsg() {
      platformDetail().then(res => {
        console.log('footer:', res)
        this.platMsg = res.data
        this.product = JSON.parse(this.platMsg[11].value).filter(item => {
          return item.name !== '心田花开网校'
        })
      })
    },
    getYear() {
      var date = new Date()
      this.year = date.getFullYear()
    }
  }
}
</script>
<style lang="less">
.footer {
  width: 100%;
  background: rgba(51, 51, 51, 1);
  .top {
    height: 260px;
    display: flex;
    justify-content: space-between;
    .item {
      text-align: left;
      margin-top: 64px;

      .title {
        .desc {
          display: block;
          font-size: 16px;

          font-weight: 400;
          line-height: 22px;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 8px;
        }
        .line {
          display: block;
          width: 28px;
          height: 3px;
          background: rgba(255, 255, 255, 1);
          margin-bottom: 24px;
        }
      }
      .content {
        .tel {
          display: flex;
          font-size: 30px;
          font-family: DIN;
          font-weight: bold;
          line-height: 36px;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 10px;
          background: rgba(51, 51, 51, 1);
          img {
            width: 32px;
            height: 32px;
          }
          span {
            margin-left: 10px;
          }
        }
        .time {
          font-size: 14px;

          font-weight: 400;
          line-height: 20px;
          color: rgba(204, 204, 204, 1);
          // margin-bottom: 26px;
          // margin-top: 20px;
        }
        .btn {
          width: 144px;
          height: 40px;
          background: rgba(251, 100, 42, 1);
          opacity: 1;
          border-radius: 20px;
          font-size: 16px;

          font-weight: 400;
          line-height: 40px;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          cursor: pointer;
        }
        .xthk-online {
          display: block;
          font-size: 14px;
          text-decoration: none;

          font-weight: 400;
          line-height: 20px;
          margin-top: 14px;
          color: rgba(204, 204, 204, 1);
          position: relative;
          .hot {
            width: 14px;
            height: 10px;
            position: absolute;
            top: 0;
            right: -16px;
          }
          &:hover {
            color: #fff;
          }
        }
        .join-us {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          text-decoration: none;

          font-weight: 400;
          line-height: 20px;
          margin-top: 14px;
          color: rgba(204, 204, 204, 1);
          & > img {
            width: 48px;
            margin-left: 4px;
          }
          &:hover {
            color: #fff;
          }
        }
      }
      .last {
        font-size: 14px;

        font-weight: 400;
        line-height: 18px;
        color: rgba(204, 204, 204, 1);
        display: flex;
        .wechat-QR {
          width: 152px;
          height: 144px;
          background: rgba(255, 255, 255, 1);
          border-radius: 5px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          right: -35px;
          top: -180px;
          &::before {
            content: '';
            position: absolute;
            bottom: -10px;
            right: 71px;
            border-top: 10px solid rgba(255, 255, 255, 1);
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
          }
          img {
            width: 128px;
            height: 128px;
          }
        }
        .last-school,
        .last-online,
        .last-service {
          .chat {
            width: 32px;
            height: 32px;
            opacity: 0.6;
          }
          &:hover {
            .chat {
              width: 32px;
              height: 32px;
              opacity: 1;
            }
            span {
              color: #fff;
            }
          }
        }
        .last-school {
          margin-right: 35px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }
        .last-online {
          margin-right: 35px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .last-service {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          .wechat-QR {
            right: -38px;
          }
        }
      }
    }
  }
  .bottom {
    height: 64px;
    background: rgba(41, 41, 41, 1);
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: rgba(153, 153, 153, 1);
    .record {
      line-height: 64px;
      .pol-num {
        margin-right: 20px;
        cursor: pointer;
        font-size: 14px;
        line-height: 20px;
        color: rgba(153, 153, 153, 1);
        text-decoration: none;
      }
    }
  }
}
</style>
